import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box,
  Chip,
  Divider
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import { User } from '../../types';

interface ProfileCardProps {
  user: User;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ user }) => {
  const getRoleColor = (role: string) => {
    switch (role) {
      case 'Emprendedor':
        return 'primary';
      case 'Mentor':
        return 'success';
      case 'Admin':
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              bgcolor: 'primary.main',
              fontSize: '2rem',
              mr: 3
            }}
          >
            {user.avatar || user.name.charAt(0)}
          </Avatar>
          <Box>
            <Typography variant="h5" gutterBottom>
              {user.name}
            </Typography>
            <Chip
              label={user.role}
              color={getRoleColor(user.role)}
              size="small"
            />
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <EmailIcon sx={{ mr: 1, color: 'text.secondary' }} />
          <Typography variant="body1">{user.email}</Typography>
        </Box>

        {user.expertise && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <SchoolIcon sx={{ mr: 1, color: 'text.secondary' }} />
            <Typography variant="body1">
              <strong>Especialidad:</strong> {user.expertise}
            </Typography>
          </Box>
        )}

        {user.projectIds && user.projectIds.length > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <WorkIcon sx={{ mr: 1, color: 'text.secondary' }} />
            <Typography variant="body1">
              <strong>Proyectos:</strong> {user.projectIds.join(', ')}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ProfileCard;
